module.exports = __webpack_public_path__ + "img/sataclogo.8948f450.png";